module.exports = __webpack_public_path__ + "assets/dba44f37ba69552ebf9ac999693fabf6.mp3";